import React from "react";
import { LocationViewModel } from "../../model/LocationViewModel";
import CustomCard from "../common/CustomCard";

interface LocationCardProps {
  location: LocationViewModel;
  onClick?: (locationId: string) => void;
  onDeleteClick?: (locationId: string) => void;
  isDeleteButtonVisible?: boolean;
}

const LocationCard: React.FunctionComponent<LocationCardProps> = ({ location, isDeleteButtonVisible, onClick, onDeleteClick }) => {
  const handleClick = () => onClick!(location.id);

  const handleDelete = () => {
    onDeleteClick!(location.id);
  };
  return (
    <CustomCard
      isOpenButtonVisible={true}
      isDeleteButtonVisible={isDeleteButtonVisible}
      onDelete={handleDelete}
      title={location.name}
      line1={location.city}
      line2={location.contactName}
      line3={location.contactEmailAddress}
      restLines={[location.contactPhoneNo]}
      onClick={handleClick}
    />
  );
};

LocationCard.defaultProps = {
  onClick: () => {},
  onDeleteClick: () => {},
  isDeleteButtonVisible: true,
} as Partial<LocationCardProps>;

export default LocationCard;
